export const SDK_VERSION = '6.0.1';
